import Service from "../../AuthService";
const ExportProducts = {
    getExportProducts(page) {
        return Service.get("/export-product?page="+page);
    },
    showExportProducts(id) {
        return Service.get("/export-product/" + id);
    },
    updateExportProducts(id, data) {
        return Service.put("/export-product/" + id, data);
    },
    createExportProducts(data) {
        return Service.post("/export-product", data);
    },
    deleteExportProducts(id) {
        return Service.delete("/export-product/" + id);
    },
    searchExportProducts(page,code, date) {
        return Service.post(
            "/search-export-product?page="+ page +"&code=" + code + "&date=" + date
        );
    }
};
export default ExportProducts;
